import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';
import Multiselect from 'multiselect-react-dropdown';
export  class AddTaskHeaderModal extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            TaskList1:[],
            options:[],
            
        }
      

    }
    componentDidMount() {
        
       

       
    }  
    onSelect(selectedList, selectedItem) {
       
      }
      
      onRemove(selectedList, removedItem) {
      
      
      }
    getscope() {
        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/ScopeList/"+"AO").then(response => response.json())
        .then(res=> {            
          this.setState ( {options:res } )
            })
            .catch(err => {
              console.log(err);
          }) 
      }
 
    
    getdomain() {
        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/Domains/"+2).then(response => response.json())
        .then(res=> {            
          this.setState ( { DomainList: res } )
            })
            .catch(err => {
              console.log(err);
          }) 
      }
      
    handleSubmit(event){
        event.preventDefault();
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = {taskid:0, taskname:event.target.taskname.value, taskheaderid:0,
        taskheadername:(event.target.taskheadername.value+event.target.taskheadernameActual.value),taskuniqueidentifier:event.target.uniqueIdentifier.value,
        taskmandatory:event.target.mandatory.value,scope:this.props.scope,level:this.props.level,
        servicegroup:this.props.servicegroup,username:this.props.username  };
    axios.post('https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTaskHeader/Post', article,options)
        .then((result)=> {   
            alert("Data Saved successfully");   
            this.props.filterchangetest(this.props.servicegroup,this.props.scope,this.props.level);      
             },
             (error) => {
                 alert("Unique Identifier should be unique");
           }) 
           
      

    




    
    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'  aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Add Task
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>
                          <Form.Group controlId='taskheader'>
                             
                             
                          <div class="col-md-6" >
                              <Form.Label>Task Header Name*</Form.Label>
                              <Form.Control type='text' defaultValue={this.props.Section} maxLength={100} style={{width:275}}  disabled name='taskheadername' required ></Form.Control>
                              <Form.Control type='text'  maxLength={100} style={{width:275}} placeholder='Enter Task Header name' name='taskheadernameActual' required ></Form.Control>
                              </div>
                             
                             
                              <div class="col-md-6" style={{marginBottom:15}} >
                              <Form.Label>Task Name*</Form.Label>
                              <Form.Control as="textarea" rows="2"  maxLength={500}  style={{width:275}} name='taskname' required placeholder='Task Name'></Form.Control>
                              </div>

                              <div class="col-md-6">
                              <Form.Label>Unique Identifier*</Form.Label>
                              <Form.Control type='text' maxLength={10} style={{width:275}} name='uniqueIdentifier' required ></Form.Control>

                              </div>
                              <div class="col-md-6">
                              <Form.Label>Mandatory*</Form.Label>
                              <Form.Select className='form-control' style={{width:275}} name='mandatory'  required>
                                  
                                  <option value="1">Yes</option>
                                  <option value="0">No</option>
                              </Form.Select>
                              
                              </div>
                             
                              
                          </Form.Group>  
                          <Form.Group>
                              <Button variant='primary' style={{margin:10}} className='btn-new btn-confirm' type='submit'>
                                  Save 
                              </Button> 

                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm' >Close
                                  
                              </Button> 
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
              
            </Modal>
            </div>
        )
    }
}